
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projectPage/ProjectPage",
      function () {
        return require("private-next-pages/projectPage/ProjectPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projectPage/ProjectPage"])
      });
    }
  